import React, { useCallback } from 'react';
import LinkIcon from '@mui/icons-material/Link';
import { IconButton } from '@mui/material';

import { LogLinkApi } from '../../../../../../../../../api';
import modalBoxes from '../../../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import { scBlue100 } from '../../../../../../../../../constants/systemColors';
import { onRequestError } from '../../../../../../../../../services/handlers';

import { LinkedParticipantsModal } from './LinkParticipantsModal/LinkedParticipantsModal';

export const LinkedParticipantsButton = ({ row, ssuPatientId, logWasLinked }) => {
  const onButtonClick = useCallback(() => {
    LogLinkApi.getLinkedParticipantForReview({
      studyId: row.studyId,
      ssuPatientId,
      itemGroupTemplateId: row.rowFormRef.itemGroupTemplateId,
      itemGroupTemplateVersionId: row.rowFormRef.itemGroupTemplateVersionId,
      rowId: row.rowId,
      review: 'CRA'
    }).then(({ data }) => {
      modalBoxes.open({
        title: 'Linked Subjects',
        component: <LinkedParticipantsModal participants={data} />,
        className: 'linked-participants-modal',
        size: 'w1100'
      });
    }, onRequestError);
  }, [row, ssuPatientId]);

  return (
    <IconButton
      data-testid="linked-participants-button"
      onClick={onButtonClick}
      sx={{ color: scBlue100 }}
      disabled={!logWasLinked}
    >
      <LinkIcon />
    </IconButton>
  );
};
